Bingo.DevelopersTrustingUs = {};

Bingo.DevelopersTrustingUs.init = function () {
    new Swiper('#developers-trusting-us-swiper', {
        slidesPerColumnFill: 'column',
        nextButton: '#developers-trusting-us .swiper-to-right',
        prevButton: '#developers-trusting-us .swiper-to-left',
        slidesPerColumn: $('#developers-trusting-us-swiper').data('one-line') ? 1 : 2,
        slideClass: 'swiper-slide',
        slidesPerView: 4,
        spaceBetween: 0,
        breakpoints: {
            767: {
                slidesPerView: 1,
            },
            1000: {
                slidesPerView: 2,
            },
            1199: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });
};
